import { jsx as _jsx } from "react/jsx-runtime";
import { Typography, Box } from '@mui/material';
import { memo } from 'react';
export const MapHeader = memo(function MapHeader() {
    return (_jsx(Box, { display: "flex", alignItems: "center", overflow: "hidden", flexGrow: 1, fontSize: "1.5rem", children: _jsx(Typography, { variant: "h6", textAlign: "center", textOverflow: "ellipsis", overflow: "hidden", ml: 1, whiteSpace: "nowrap", color: "textPrimary", children: "\u041A\u0430\u0440\u0442\u0430 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432" }) }));
});
